import { render, staticRenderFns } from "./gui_tabs.vue?vue&type=template&id=52e38212&"
import script from "./gui_tabs.vue?vue&type=script&lang=js&"
export * from "./gui_tabs.vue?vue&type=script&lang=js&"
import style0 from "./gui_tabs.vue?vue&type=style&index=0&id=52e38212&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports